module.exports = __webpack_public_path__ + "assets/images/sombra.a3e79864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sombra.png
// module id = 806
// module chunks = 1